var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { RelationshipService } from "~/services/repair-service/relationship.service";
var AddRelevanceRelation = /** @class */ (function (_super) {
    __extends(AddRelevanceRelation, _super);
    function AddRelevanceRelation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kosekiModel = {
            name: "",
            idNo: "",
            relation: "",
            relationPersonName: "",
            relationPersonIdNo: "",
            remark: ""
        };
        _this.loading = {
            state: false
        };
        _this.dialog = {
            detail: false
        };
        _this.rulesAdd = {
            name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
            idNo: [{ required: true, message: "请输入身份证号", trigger: "blur" }]
        };
        return _this;
    }
    AddRelevanceRelation.prototype.success = function () {
        this.close();
    };
    AddRelevanceRelation.prototype.close = function () {
        this.reset();
    };
    AddRelevanceRelation.prototype.mounted = function () { };
    // 保存户籍信息
    AddRelevanceRelation.prototype.save = function () {
        var _this = this;
        var addform = this.$refs["add-form"];
        addform.validate(function (valid) {
            if (!valid)
                return;
            _this.loading.state = true;
            _this.relationshipService
                .insert(_this.kosekiModel, _this.loading)
                .subscribe(function (data) {
                _this.$message.success("添加成功!");
                _this.success();
            });
        });
    };
    AddRelevanceRelation.prototype.reset = function () {
        var add = this.$refs["add-form"];
        add.resetFields();
    };
    __decorate([
        Dependencies(RelationshipService)
    ], AddRelevanceRelation.prototype, "relationshipService", void 0);
    __decorate([
        Emit("success")
    ], AddRelevanceRelation.prototype, "success", null);
    __decorate([
        Emit("close")
    ], AddRelevanceRelation.prototype, "close", null);
    AddRelevanceRelation = __decorate([
        Component({
            components: {}
        })
    ], AddRelevanceRelation);
    return AddRelevanceRelation;
}(Vue));
export default AddRelevanceRelation;
